<template>
  <Anchor
    v-if="item.link"
    :item="item.link"
    :hide-text="true"
    class="b-menu-vehicle">
    <div class="b-menu-vehicle__picture mb-15">
      <LazyImage
        v-if="item.image"
        :image="item.image"
        class="object-fit-cover" />
    </div>
    <div class="btn btn-link-dark btn-icon-end btn-forward">
      <span>{{ item.link.text }}</span>
      <i class="icon-arrow-long-right"></i>
    </div>
  </Anchor>
</template>

<script>
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'

export default {
  components: { Anchor, LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-link-dark {
  justify-content: space-between;
  gap: 20px;
  i {
    padding-right: 20px;
  }
}
</style>
